export interface ConfigureRefreshOperationResult {
    raftCommandIndex: number;
}